import { useState, useEffect } from 'react';
import axios from 'axios';
import { apiHostUrl } from "@/config/publicConfig";

export default (url, isFile = false) => {
  const baseUrl = apiHostUrl();
  const baseOption = {
    method: "GET",
    headers: isFile
      ? {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        }
      : {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
  };
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);
  const [meta, setMeta] = useState(null);
  const [options, setOptions] = useState({});

  const doFetch = (options = {}) => {
    setOptions({
      ...baseOption,
      ...options,
    });
    setIsLoading(true);
  };

  useEffect(() => {
    let skipGetResponseAfterDestroy = false;
    if (!isLoading) {
      return;
    }
    setIsLoading(true);
    axios(baseUrl + url, options)
      .then((res) => {
        if (!skipGetResponseAfterDestroy) {
          if (res.status == 204) {
            setResponse({ data: { status: "ok" } });
          } else {
            setResponse(res.data);
            if (res.data.meta) {
              setMeta(res.data.meta);
            }
          }
          setIsLoading(false);
        }
      })
      .catch((err) => {
        if (!skipGetResponseAfterDestroy) {
          if (err.response) {
            setError(err.response.data);
          }
          setIsLoading(false);
        }
      });

    return () => {
      skipGetResponseAfterDestroy = true;
    };
  }, [isLoading]);

  return [{ response, isLoading, error, meta }, doFetch];
};
